var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Site en construction")]),_c('h2',[_vm._v("Disponible prochainement")])])
}]

export { render, staticRenderFns }